import React from "react";
import { useViewport } from 'components/general/useViewPort'
import Label from "components/general/Label"
import SportCode from "components/common/SportCode"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faArrowUp} from "@fortawesome/free-solid-svg-icons";


const Gates = ({config, row, isCurrent} ) => {
  const { breakPoint } = useViewport();
  const gates = config?.extendedConfig?.filter(ec => ec?.code === 'GATE')?.sort((a, b) => a?.pos - b?.pos);
  const time = row?.eventUnitEntries?.find(eui => eui?.eue_code === 'START_TIME')?.eue_value;

  return (
      <>
      <table className="table table-detail">
          {time !== undefined && !isCurrent
              ? <caption className=" fw-bold"><Label data="LabelStartTime"/>: {time.substring(0, 5)} </caption>            
              : ''
          }            
          <thead>
              <tr>
                  <th><Label data="HeaderGate"/></th>
                  {   
                      gates.map(gate => {
                          let direction = gate?.extension?.find(e => e.code === 'DIRECTION')?.value
                          let header = isNaN(gate.value) 
                              ? <SportCode code={gate.value} discipline="CSL" entity="@Obstacle" />
                              : (direction === 'U')
                                  ? <>{gate.value} <FontAwesomeIcon className='move-arrow-up' icon={faArrowUp} /></>
                                  : gate.value
                          return(
                              <th key={`header-${gate.pos}`} className="w-5 text-center text-nowrap">{header}</th>
                          )
                      })
                  }
              </tr>
          </thead>
          <tbody>
              <tr>
                  <th><Label data="HeaderFaults"/></th>
                  {   
                      gates.map(gate => {
                          let value = row?.extendedResults?.find(er => er.er_code === 'GATE_PTY' && er.er_pos === gate.pos)?.er_value
                          let colour = (value === '-') 
                              ? 'bg-green' 
                              : (value === 'FLT')  
                                  ? 'bg-yellow'
                                  : ''
                          return(
                            <td key={`row-${gate.pos}`} className={`text-center ${colour}`}>
                                {
                                (value === 'FLT')
                                    ? <SportCode code={value} discipline="CSL" entity="@ResultType" abbr={true}/>
                                    : value
                                }
                            </td>
                          )
                      })
                  }
              </tr>
          </tbody>
      </table>
      </>
  )
}   
export default Gates;